/* istanbul ignore file */
import { BigFormRow } from 'framework/ui/layout';
import { Grid2 as Grid } from '@mui/material';
import { TextInput, DateInput, useInputHelper } from 'framework/form';
import DocumentTypeDropdown from './DocumentTypeDropdown';
import { DocumentScanUploaderInput } from 'domain/shared/employee';

const SCANS_SOURCE = 'scansIds';

interface EducationalDocumentInputProps {
  source: string;
  value: any;
}

const EducationalDocumentInput: React.FC<EducationalDocumentInputProps> = props => {
  const { getSource, getValue, getRawOnChangeCallback } = useInputHelper(props);
  const source = getSource();

  const documentData = getValue() || {};
  const onChangeCallback = getRawOnChangeCallback();

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6, xl: 4 }}>
          <DocumentTypeDropdown
            source={`${source}.type`}
            label="Document type"
            value={documentData.type}
            onChangeCallback={onChangeCallback}
            placeholder="Document Type"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6, xl: 4 }}>
          <TextInput
            source={`${source}.number`}
            label="Series and number"
            value={documentData.number}
            onChangeCallback={onChangeCallback}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6, xl: 4 }}>
          <DateInput
            source={`${source}.dateOfIssue`}
            label="Date of issue"
            value={documentData.dateOfIssue}
            onChangeCallback={onChangeCallback}
          />
        </Grid>
      </Grid>
      <BigFormRow>
        <div className="education-list__document-scan">
          <DocumentScanUploaderInput
            label="Document scans"
            source={`${source}.${SCANS_SOURCE}`}
            value={documentData[SCANS_SOURCE]}
          />
        </div>
      </BigFormRow>
    </>
  );
};

export default EducationalDocumentInput;
